import { BpList } from '../../../../shared/components/cards/list/BpList'
import { BpListItem } from '../../../../shared/components/cards/list/bp-list-item/BpListItem'
import {
  useGetAdOverviewPublisherQuery,
  usePostAdOverviewPublisherMutation,
} from '../../../../app/api'
import { Preloader } from '../../../../shared/components/cards/preloader/Preloader'
import { BpAnchor } from '../../../../shared/components/text/anchor/BpAnchor'
import { EditAffiliateForm, IEditAffiliateFormData } from './EditAffiliateForm'
import { useRef, useState } from 'react'
import { SubmitHandler } from 'react-hook-form'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { hideModal } from '../../../../app/store/reducers/AppSlice'
import { BpCard } from '../../../../shared/components/cards/card/BpCard'
import { FormControls } from '../../../../shared/components/forms/form-controls/FormControls'
import clsx from 'clsx'
import styles from './EditAffiliateModal.module.scss'

export interface IEditAffiliateModalParams {
  publisherId: number
}

export const EditAffiliateModal = ({ publisherId: id }: IEditAffiliateModalParams) => {
  const dispatch = useAppDispatch()
  const { data, isLoading, isFetching } = useGetAdOverviewPublisherQuery({ id })
  const [editPublisher] = usePostAdOverviewPublisherMutation()
  const isShowPreloader = isFetching || isLoading
  const ref = useRef<HTMLFormElement>(null)
  const [isDirty, setIsDirty] = useState<boolean>(false)

  const onSubmit: SubmitHandler<IEditAffiliateFormData> = (data: IEditAffiliateFormData) =>
    editPublisher({ body: { id, ...data } })

  if (data?.data) {
    const { name, updated_at, site, created_at, comment, email, project } = data.data

    const title = (
      <>
        <span>Publisher</span> <span className={clsx(styles.titleName)}>{name}</span>
      </>
    )

    const footer = (
      <FormControls
        disabled={!isDirty}
        onSubmit={() => {
          if (ref.current) ref.current.dispatchEvent(new Event('submit', { bubbles: true }))
        }}
        onCancel={() => dispatch(hideModal())}
      />
    )

    return (
      <>
        {isShowPreloader && <Preloader />}
        {!isShowPreloader && (
          <BpCard footer={footer} title={title}>
            <BpList>
              <>
                {created_at && <BpListItem title='Created at'>{created_at}</BpListItem>}
                {updated_at && <BpListItem title='Updated at'>{updated_at}</BpListItem>}
                {project && <BpListItem title='Project'>{project}</BpListItem>}
                {site && (
                  <BpListItem title='Site'>
                    <BpAnchor href={`https://${site}`} target='_blank'>
                      {site}
                    </BpAnchor>
                  </BpListItem>
                )}
              </>
            </BpList>
            <EditAffiliateForm
              ref={ref}
              comment={comment}
              email={email}
              name={name}
              onDirty={setIsDirty}
              onSubmit={onSubmit}
            />
          </BpCard>
        )}
      </>
    )
  }

  return <Preloader />
}
